function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("metadata", null, "\n Created by potrace 1.16, written by Peter Selinger 2001-2019\n ");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1688 1277 l-3 -963 -785 118 c-432 65 -794 117 -805 115 -18 -2  1566 -540 1591 -540 7 0 136 51 288 114 l276 114 0 890 0 890 -273 113 c-149  62 -275 112 -279 112 -5 0 -9 -433 -10 -963z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M333 1752 l-192 -157 0 -75 0 -75 124 -80 c69 -43 125 -82 125 -85 0  -3 -57 -41 -125 -85 l-125 -80 0 -72 0 -72 195 -160 195 -160 67 20 c38 11 83  25 101 30 l32 11 0 179 0 179 180 -120 c99 -66 185 -120 192 -120 7 0 76 20  153 44 l140 44 0 363 0 363 -150 47 -149 47 -178 -119 c-98 -66 -180 -119  -183 -119 -3 0 -5 79 -5 175 l0 174 -99 31 c-54 16 -100 30 -102 29 -2 0 -90  -71 -196 -157z m173 -349 c-2 -3 -59 25 -126 60 l-122 65 98 69 c55 38 110 77  124 86 l25 17 3 -146 c1 -81 1 -149 -2 -151z m624 -122 l0 -199 -200 96 c-110  53 -200 99 -200 102 0 6 380 198 393 199 4 1 7 -89 7 -198z m-620 -271 c0 -82  -2 -150 -5 -150 -2 0 -59 39 -126 86 l-121 86 119 64 c65 35 121 63 126 64 4  0 7 -67 7 -150z"
}));

const SvgAppcenter = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "225.000000pt",
  height: "225.000000pt",
  viewBox: "0 0 225.000000 225.000000",
  preserveAspectRatio: "xMidYMid meet",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAppcenter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/appcenter.ac9cd69e.svg";
export { ForwardRef as ReactComponent };